




































































import {
  Vue,
  Component,
  Prop,
  Emit,
} from 'vue-property-decorator';
import AuthConnector from '@/connector/Auth.vue';
import DialogConnector from '@/connector/Dialog.vue';
import ProfileConnector from '@/connector/Profile.vue';
import TransactionService from '@/services/TransactionService';

const transactionService = new TransactionService();

@Component({
  components: {
    AuthConnector,
    DialogConnector,
    ProfileConnector,
  },
})
export default class RefundLossDialog extends Vue {
  @Prop({ type: Boolean, required: true }) open: boolean|undefined;

  public loading: boolean = false;

  get dialog() {
    return this.open;
  }

  set dialog(value) {
    this.close();
  }

  // eslint-disable-next-line class-methods-use-this
  generateRefUrl(refCode: string) {
    return `${window.location.hostname}?ref=${refCode}`;
  }

  @Emit('close-dialog')
  // eslint-disable-next-line class-methods-use-this
  close() {
    return false;
  }

  public async copyAfLink(link: string) {
    navigator.clipboard.writeText(link);
    this.$store.commit('Snackbar/showNotification', { message: 'คัดลอกลิงก์แล้ว', error: false });
  }

  public async refundLoss() {
    try {
      this.loading = true;
      await transactionService.refundLoss();
      this.loading = false;
      await this.$store.dispatch('Profile/getProfile');
      this.$store.commit('Snackbar/showNotification', { message: 'ถอนเงินสำเร็จ', error: false });
    } catch (e) {
      this.loading = false;
      this.$store.commit('Snackbar/showNotification', { message: e.message, error: true });
    }
  }
}
